import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import { FiArrowLeft } from 'react-icons/fi';

const Legal = ({ type }) => {
  const { t } = useLanguage();
  const isPrivacy = type === 'privacy';
  const title = isPrivacy ? t('legal.privacyTitle') : t('legal.termsTitle');
  const intro = isPrivacy ? t('legal.privacyIntro') : t('legal.termsIntro');
  const items = isPrivacy ? t('legal.privacyItems') : t('legal.termsItems');

  return (
    <div className="bg-slate-50 min-h-screen py-16 md:py-24">
      <div className="container mx-auto px-6 max-w-4xl">
        <Link to="/" className="inline-flex items-center gap-2 text-glass-blue font-bold mb-8 hover:text-blue-700">
          <SafeIcon icon={FiArrowLeft} />
          {t('nav.home')}
        </Link>
        <div className="bg-white border border-slate-100 rounded-3xl shadow-sm p-6 sm:p-10 md:p-12">
          <p className="text-sm font-bold uppercase tracking-widest text-slate-400 mb-4">{t('legal.updated')}</p>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">{title}</h1>
          <p className="text-lg text-slate-600 leading-relaxed mb-8">{intro}</p>
          <ul className="space-y-5 list-disc pl-5">
            {items.map((item) => (
              <li key={item} className="text-slate-700 leading-relaxed marker:text-glass-blue">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Legal;
